module.exports = __webpack_public_path__ + "074aa2da6851c57a41bf72a227ee7506.MP3";